import React from "react"
import { Card, CardContent, Typography } from '@material-ui/core'

const VideoGallery = () => {
  return (
    <Card style={{ minHeight: '350px', margin: '50px' }}>
      <CardContent style={{ padding: '30px' }}>
        <Typography variant="h5" style={{
          borderBottom: '1px solid currentColor',
          marginBottom: '1rem',
          paddingBottom: "5px",
          fontWeight: 'bold',
        }}>
          Video Gallery
        </Typography>
        <Typography variant="p">
          No Gallery Details Available
        </Typography>
      </CardContent>
    </Card>
  )
}

export default VideoGallery